import { PerformedByRequestDTO } from './performed-by-request-dto';

export interface ReadUserRequestDTO extends PerformedByRequestDTO {
    userId?: number;
    userEmail?: string;
    roleCd?: string;
    contextCd?: string;
    userRoleContextId?: number;
    languageCd?: string;
}

export interface ResendActivationEmailRequestDTO extends PerformedByRequestDTO {
    userId?: number;
    userEmail?: string;
}
